import React, {Component} from "react";
import {Icon} from "bloomer";
import Card from "../../../elements/Card";
import Button from "../../../elements/Button";
import {getRandomJoke} from "../../../api/models/GeekJokes";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import InformationCard from "../../../elements/InformationCard";
import Spacer from "../../../elements/Spacer";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import SectionName from "../../../elements/SectionName";

interface IJokesModelState {
    loading: boolean;
    result: string;
    showRefreshButton: boolean;
    errorMessage: string;
}

class JokesModel extends Component<{}, IJokesModelState> {

    public constructor(props: {}) {
        super(props);

        this.state = {
            loading: false,
            result: "",
            showRefreshButton: false,
            errorMessage: ""
        };
    }

    public componentDidMount() {
        SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.JOKES);
        this.loadJoke();
    }

    public loadJoke = async () => {
        if (this.state.loading) {
            this.setState({result: null});
            return;
        }

        this.setState({
            loading: true,
            result: "",
            errorMessage: ""
        });

        let errorOccurred = false;

        const response = await getRandomJoke().catch((error) => {
            if (ErrorUtils.requestLimitExceeded(error.response)) {
                this.setState({
                    loading: false,
                    showRefreshButton: true
                });
                toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
            } else {
                this.setState({
                    loading: false,
                    showRefreshButton: true,
                    errorMessage: "Couldn't get joke."
                });
            }
            errorOccurred = true;
        });

        if (errorOccurred) {
            return;
        }

        if (response && response.data && response.data.joke) {
            this.setState({
                loading: false,
                showRefreshButton: true,
                result: response.data.joke
            });
        } else {
            this.setState({
                loading: false,
                showRefreshButton: true,
                errorMessage: "Couldn't get joke."
            });
        }

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.JOKES);
    };

    public onRefresh = (e: any) => {
        e.target.blur();
        this.loadJoke();
    };

    public render() {
        return <ModelContentContainer>
            <Card>
                <Spacer/>
                {
                    this.state.showRefreshButton ?
                        <Button onClick={this.onRefresh}>
                            <Icon className="fas fa-sync-alt" style={{marginRight: '5px'}}/>
                            {"Get Random Joke"}
                        </Button> : <></>
                }
                <Spacer/>
                {
                    this.state.loading && <div style={{textAlign: 'center'}}>
                        <span>Loading...</span>
                        <Icon className="fas fa-spinner fa-spin"/>
                    </div>
                }
                {
                    !this.state.loading && this.state.result ? <div>
                        <SectionName>Output:</SectionName>
                        <InformationCard>{this.state.result}</InformationCard>
                    </div> : <></>
                }
                {
                    !this.state.loading && this.state.errorMessage ? <div>
                        <InformationCard>{this.state.errorMessage}</InformationCard>
                    </div> : <></>
                }
                <Spacer/>
            </Card>
        </ModelContentContainer>;
    }
}

export default JokesModel;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Jokes/JokesModel.tsx